import React from 'react';

import {
  SearchLoadMore as SearchLoadMoreOriginal,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const SearchLoadMore = ({ data }) => {
  return (
    <div className="SearchLoadMore">
      <SearchLoadMoreOriginal
        label={<span>Laat meer zien <i className="icon icon-arrow-right" /></span>}
        data={data}
      />
    </div>
  );
};

export default SearchLoadMore;
